export const validation = {
	badge: {
		validated: "Validated",
		pending: "Pending validation",
		preExisting: "Pre-existing",
	},
	filter: {
		label: "Status",
		all: "All",
		pending: "Pending validation",
		validated: "Validated",
	},
	banner: {
		title: "You have fiscal data to validate!",
		message: "Confirm the data to use these fiscal profiles.",
	},
	card: {
		confirmAction: "Confirm data",
		validateAction: "Validate data",
		viewDetails: "See details",
	},
	drawerNotice: {
		pendingValidation: "Validate the data to use this fiscal profile",
		pendingValidationGroup: "Validate the data to use this fiscal group",
	},
	modalConfirm: {
		title: "Confirm fiscal data",
		message:
			"Are you sure you want to validate this fiscal profile? Once confirmed it will be available for use in the system.",
		confirm: "Confirm data",
		success: "Data validated successfully!",
	},
	modalReject: {
		title: "Reject fiscal data",
		message:
			"Are you sure you want to reject these changes? The record will revert to the previous state.",
		confirm: "Confirm rejection",
		success: "Data rejected.",
		// New registration (no active version): rejecting deletes it permanently.
		newRegistrationProfile: {
			title: "Reject fiscal profile",
			messageBold: "Are you sure you want to reject this fiscal profile?",
			message: "Once confirmed it will be permanently deleted from the system.",
			confirm: "Reject fiscal profile",
		},
		newRegistrationGroup: {
			title: "Reject fiscal group",
			messageBold: "Are you sure you want to reject this product fiscal group?",
			message: "Once confirmed it will be permanently deleted from the system.",
			confirm: "Reject fiscal group",
		},
	},
	infoBlock: {
		title: "Fiscal data validation",
		validatedAt: "Validation date/time",
		validatedBy: "Validated by",
		newBadge: "New",
	},
	drawerFooter: {
		confirmData: "Confirm data",
		reject: "Reject",
		editProfile: "Edit profile",
		editGroup: "Edit group",
	},
	// Support tooltips on the registration listing (Figma node 3066-7771).
	tooltip: {
		pendingProfile: "Validate the data to use this fiscal profile",
		pendingGroup: "Validate the data to use this product fiscal group",
		preExistingProfile:
			"Fiscal profile created before data validation. It doesn't need to be validated to be used.",
		preExistingGroup:
			"Product fiscal group created before data validation. It doesn't need to be validated to be used.",
		validatedBy: "Fiscal data validated on {{date}} by",
		validated: "Fiscal data validated on {{date}}",
	},
	form: {
		saveAndValidate: "Save and Validate",
		saveAndValidateSuccess: "Saved and validated successfully.",
	},
};
